<template>
  <div class="p-cooperation">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>校企合作</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <div>
        <div class="item" v-for="(item, index) in list" :key="index">
          <div
            class="left_img m-h"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
          ></div>
          <div class="right_nav">
            <router-link
              :to="'/article_details/' + item.id"
              class="right_nav_title"
              >{{ item.title }}</router-link
            >
            <p class="right_nav_time">
              {{ item.tips }}
            </p>
            <div class="line"></div>
            <router-link :to="'/article_details/' + item.id" class="details m-h"
              >查看详情></router-link
            >
          </div>
        </div>
      </div>
    </div>
    <!--分页-->
    <el-pagination
      class="kf-pagination"
      background
      layout="prev, pager, next"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      @current-change="onCurrentChange"
    />
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 280px;
  background: url(~@/assets/img/case/title.png) no-repeat center;
  background-size: cover;
}
.title_text {
  width: 360px;
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  line-height: 84px;
  text-align-last: justify;
  text-align: justify;
}
.details {
  display: inline-block;
  width: 120px;
  height: 40px;
  background: rgba(255, 128, 18, 0);
  border-radius: 2px;
  border: 1px solid #000000;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}
.item {
  display: flex;
  margin-bottom: 60px;
  .left_img {
    margin-right: 40px;
    width: 420px;
    height: 280px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}
.right_nav {
  height: 280px;
  //margin-top: -5px;
  //overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.right_nav_title {
  display: inline-block;
  height: 45px;
  font-size: 28px;
  font-weight: 400;
  color: #000000;
  line-height: 45px;
  //margin-bottom: 20px;
}
.right_nav_title:hover {
  color: #ff8012;
}
.right_nav_time {
  width: 640px;
  height: 48px;
  font-size: 16px;
  font-weight: 400;
  color: #656878;
  line-height: 24px;
}
.line {
  width: 60px;
  height: 2px;
  background: #0030aa;
  //margin-top: 40px;
  //margin-bottom: 82px;
}
</style>
